<template>
	<div class=".d-none">
		<Snackbar />
		<ConfirmationDialog />
	</div>
</template>

<script>
	import Snackbar from "./Snackbar";
	import ConfirmationDialog from "./ConfirmationDialog";

	export default {
		components: {
			Snackbar,
			ConfirmationDialog
		}
	};
</script>